module.exports = __webpack_public_path__ + "afca5579257a765c48f9b12ec8578af0.png";